import { all, fork } from "redux-saga/effects";
import authentication from "./sagas/authentication";
import cadd from "./sagas/cadd";
import pme from "./sagas/pme";
import location from "./sagas/location";
import admin from './sagas/admin';
import forms from './sagas/forms';
import scp from './sagas/scp';
import scl from './sagas/scl';
import project from './sagas/project';
import dashboard from './sagas/dashboard';
import stakeholder from './sagas/stakeholder';
import lir from './sagas/lir';
import events from './sagas/events';
import documents from './sagas/documents';
import sp from './sagas/sp';
import bpe from './sagas/bpe';
import gm from './sagas/gm';
import go from './sagas/go';
import im from './sagas/im';
import sci from './sagas/sci';
import is from './sagas/is';
import ic from './sagas/ic';
import adm from './sagas/adm';
import analysis from './sagas/analysis';
import notifications from './sagas/notifications';
import amp from './sagas/amp';
import mineProfile from './sagas/mine-profile';
import ownershipKyc from "./sagas/ownership-kyc";
import applicationForm from "./sagas/application-form";
import programs from "./sagas/programs";
import esgAssessment from "./sagas/esg-assessment";
import linkedSubjects from "./sagas/linked-subjects";

function* rootSaga() {
  yield all([
    fork(authentication),
    fork(cadd),
    fork(admin),
    fork(location),
    fork(pme),
    fork(forms),
    fork(scp),
    fork(scl),
    fork(project),
    fork(dashboard),
    fork(stakeholder),
    fork(lir),
    fork(events),
    fork(documents),
    fork(sp),
    fork(bpe),
    fork(gm),
    fork(go),
    fork(im),
    fork(sci),
    fork(is),
    fork(adm),
    fork(ic),
    fork(analysis),
    fork(notifications),
    fork(amp),
    fork(mineProfile),
    fork(ownershipKyc),
    fork(applicationForm),
    fork(programs),
    fork(esgAssessment),
    fork(linkedSubjects),
  ]);
}

export default rootSaga;
